"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoAlert = InfoAlert;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = require("../constants/icons");

var _cssModifierUtilities = require("../utilities/cssModifierUtilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function InfoAlert(_ref) {
  var children = _ref.children,
      cssClassModifiers = _ref.cssClassModifiers;
  var alertClass = (0, _cssModifierUtilities.buildClassName)('alert', cssClassModifiers);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: alertClass
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "alert__icon ".concat(_icons.icons.infoFilled)
  }), children);
}

InfoAlert.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  cssClassModifiers: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
InfoAlert.defaultProps = {
  cssClassModifiers: []
};